import * as React from 'react';
import { Operations } from '@grandvisionhq/carts-v2';

const useUpdateCartCache = ()=>{
    const updateCacheWithCart = React.useCallback(({ cart , cache  })=>{
        const cacheData = cache.readQuery({
            query: Operations.Queries.GET_CART,
            variables: {
                id: cart.id
            }
        });
        const validationErrors = cacheData && cacheData.cart.validationErrors || null;
        const failures = cacheData && cacheData.cart.failures || null;
        cache.writeQuery({
            query: Operations.Queries.GET_CART,
            variables: {
                id: cart.id
            },
            data: {
                cart: {
                    __typename: 'CartQueryResponse',
                    cart,
                    validationErrors,
                    failures
                }
            }
        });
    }, []);
    return {
        updateCacheWithCart
    };
};

export { useUpdateCartCache };
//# sourceMappingURL=use-update-cart-cache.js.map
